<template>
<ul class="breadcrumbs">
  <li :class="{selected: !pagesStore.getCurrentPage}" @click="pagesStore.setPage('index')">Винная карта центра Москвы</li>
  <li v-if="pagesStore.currentPage" class="selected">{{ pagesStore.getCurrentPage.title }}</li>
</ul>
</template>
<script setup lang="ts">
import {usePagesStore} from "@stores/pages";

const pagesStore = usePagesStore();

defineOptions({
  name:'AppBreadCrumbs'
})
</script>
<style scoped lang="scss">
  .breadcrumbs{
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: var(--font-size-24);
    line-height: var(--line-height-28);
    text-transform: uppercase;
    font-family: var(--ff-heading);
    display: flex;
    align-items: center;
    li {
      color: var(--color-primary-ghost-30);
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: color 0.5s;
      &:first-child{
        &:not(.selected):hover{
          color: var(--color-primary);
        }
        &.selected{
          cursor: default;
        }
      }

      &.selected {
        color: var(--color-secondary);

      }
      &:nth-child(2) {
        cursor: default;
        &:before {
          content: '•';
          display: block;
          margin-left: var(--space-12);
          margin-right: var(--space-12);
          color: var(--color-primary);
          height: 0.01rem;
          margin-top: -3rem;

        }
      }
    }
  }
</style>